import { supabase } from './supabaseClient';

export const fetchClasses = async () => {
    const { data, error } = await supabase
        .from('classes')
        .select('*')
        .order('created_at', { ascending: true });
    
    if (error) {
        console.error('Error fetching classes:', error);
        return [];
    }
    return data;
};

export const createClass = async (classData) => {
    // Ensure we only send columns that exist in our new schema
    const cleanData = {
        name: classData.name,
        title: classData.title,
        ageRange: classData.ageRange,
        seats: classData.seats,
        classTime: classData.classTime,
        tuitionFee: classData.tuitionFee,
        image: classData.image
    };

    const { data, error } = await supabase
        .from('classes')
        .insert([cleanData])
        .select();
    
    if (error) {
        console.error('Error creating class:', error);
        throw error;
    }
    return data[0];
};

export const updateClass = async (id, classData) => {
    const cleanData = {
        name: classData.name,
        title: classData.title,
        ageRange: classData.ageRange,
        seats: classData.seats,
        classTime: classData.classTime,
        tuitionFee: classData.tuitionFee,
        image: classData.image
    };

    const { data, error } = await supabase
        .from('classes')
        .update(cleanData)
        .eq('id', id)
        .select();
    
    if (error) {
        console.error('Error updating class:', error);
        throw error;
    }
    return data[0];
};

export const deleteClass = async (id) => {
    const { error } = await supabase
        .from('classes')
        .delete()
        .eq('id', id);
    
    if (error) {
        console.error('Error deleting class:', error);
        throw error;
    }
};
